// extracted by mini-css-extract-plugin
export default {"svg-img":"CustomToggle_svg-img__f3IAo","acc-toggle":"CustomToggle_acc-toggle__kbtSm"};